<template>
  <span class="page-select-wrap">
    <el-select
      :value="value"
      placeholder="请选择主页"
      @change="handleChange"
      filterable
      :clearable="clearable"
    >
      <el-option
        v-for="page in pageList"
        :key="page.id"
        :label="page.name"
        :value="page.id"
        style="height: 85px"
        :disabled="!page.is_published"
      >
        <div class="pageItems">
          <div class="pageImg">
            <el-image :src="page.picture_url"></el-image>
          </div>
          <div class="pageMsg">
            <p>
              <el-tooltip
                content="检测到提示主页已经被封"
                v-if="page.isBlocked"
              >
                <i class="el-icon-lock" style="color: #f00"></i>
              </el-tooltip>
              {{ page.name }}
            </p>
            <div>编号：{{ page.id }}</div>
            <div class="page-select-capacity">
              <span :style="{ color: getCapacityColor(page.id) }">
                容量：{{ getCapacityText(page.id) }}
              </span>
              <i
                class="el-icon-refresh"
                :class="{ 'is-loading': isCapacityLoading(page.id) }"
                style="margin-left: 4px; cursor: pointer; font-size: 12px; color: #409eff"
                @click.stop="refreshCapacity(page)"
              ></i>
            </div>
          </div>
        </div>
        <set-page-status
          v-if="showSetStatus"
          :page="page"
          @getList="handleRefreshPages"
        ></set-page-status>
      </el-option>
      <div slot="empty" class="empty" v-loading="loadPages">
        <i class="iconfont icon-wushuju"></i>
        <p>暂无数据</p>
      </div>
    </el-select>
    <el-tooltip
      class="item"
      effect="dark"
      content="强制刷新主页，清除本地缓存主页数据"
      placement="top"
    >
      <el-button
        icon="el-icon-refresh"
        @click="handleRefreshPages"
        type="text"
        size="mini"
        :disabled="loadPages"
      ></el-button>
    </el-tooltip>
    <span
      class="page-select-total"
      v-show="value && currentCapacity"
    >
      总容量：{{ currentCapacity ? currentCapacity.limit : 0 }}，已使用：{{ currentCapacity ? currentCapacity.used : 0 }}
    </span>
  </span>
</template>

<script>
import setPageStatus from '@/views/adManagement/createAd/components/setPageStatus.vue';
import { pageVolumes } from '@/api/creatAd';

export default {
  name: 'PageSelect',
  components: { setPageStatus },
  props: {
    // 选中的 page_id，支持 v-model
    value: {
      type: [String, Number],
      default: '',
    },
    // 主页列表
    pageList: {
      type: Array,
      default: () => [],
    },
    // 广告账户 ID
    accountId: {
      type: [String, Number],
      default: '',
    },
    // 第三方用户 ID（thirdLoginUserId）
    targetUserId: {
      type: [String, Number],
      default: '',
    },
    // 是否加载中
    loadPages: {
      type: Boolean,
      default: false,
    },
    // 是否显示编辑主页状态按钮
    showSetStatus: {
      type: Boolean,
      default: true,
    },
    // 是否可清空
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // 存储各主页容量数据，key 为 page.id
      capacityMap: {},
    };
  },
  computed: {
    // 当前选中主页的容量信息
    currentCapacity() {
      return this.capacityMap[this.value] || null;
    },
  },
  watch: {
    // 当外部设置了初始值时，自动加载容量
    value: {
      handler(val) {
        if (val && this.accountId && !this.capacityMap[val]) {
          this.fetchCapacity(val);
        }
      },
      immediate: true,
    },
    // accountId 变化后，如果已有选中值，重新加载容量
    accountId(val) {
      if (val && this.value && !this.capacityMap[this.value]) {
        this.fetchCapacity(this.value);
      }
    },
  },
  methods: {
    handleChange(pageId) {
      this.$emit('input', pageId);
      this.$emit('change', pageId);
      if (pageId) {
        this.fetchCapacity(pageId);
      }
    },
    handleRefreshPages() {
      this.$emit('refresh-pages');
    },
    // 获取容量颜色
    getCapacityColor(pageId) {
      const info = this.capacityMap[pageId];
      if (!info || info.loading || info.limit === undefined) return '#999';
      if (info.used >= info.limit) return '#f00';
      if (info.used >= info.limit * 0.8) return '#faad14';
      return '#67C23A';
    },
    // 获取容量文本
    getCapacityText(pageId) {
      const info = this.capacityMap[pageId];
      if (!info || info.loading || info.limit === undefined) return '-';
      return `${info.used}/${info.limit}`;
    },
    // 是否正在加载容量
    isCapacityLoading(pageId) {
      const info = this.capacityMap[pageId];
      return info && info.loading;
    },
    // 获取单个主页容量
    fetchCapacity(pageId) {
      const params = {
        pageId,
        accountId: this.accountId,
      };
      this.$set(this.capacityMap, pageId, {
        ...(this.capacityMap[pageId] || {}),
        loading: true,
      });
      pageVolumes(params, this.targetUserId)
        .then((res) => {
          this.$set(this.capacityMap, pageId, {
            limit: res.data.limit_on_ads_running_or_in_review,
            used: res.data.ads_running_or_in_review_count,
            loading: false,
          });
          // 通知父组件容量信息已更新
          this.$emit('capacity-loaded', {
            pageId,
            limit: res.data.limit_on_ads_running_or_in_review,
            used: res.data.ads_running_or_in_review_count,
          });
        })
        .catch(() => {
          this.$set(this.capacityMap, pageId, {
            ...(this.capacityMap[pageId] || {}),
            loading: false,
          });
        });
    },
    // 刷新单个主页容量（点击下拉项中的刷新按钮）
    refreshCapacity(page) {
      if (this.isCapacityLoading(page.id)) return;
      this.fetchCapacity(page.id);
    },
  },
};
</script>

<style lang="scss">
.page-select-wrap {
  display: inline-block;
}
.page-select-total {
  font-size: 12px;
  color: #999;
}
.page-select-capacity {
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  .is-loading {
    animation: pageSelectRotating 1s linear infinite;
  }
}
@keyframes pageSelectRotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
